import { useTranslation } from 'react-i18next';
import { StyledTitle } from 'components/StyledTitle';
import { GreetingBox } from './styledComponent';
import { useBreakpoint } from 'hooks';

type WelcomeMessageProps = {
  alertsNum?: number;
  policyHolderFirstName?: string;
};

export const WelcomeMessage = ({ alertsNum, policyHolderFirstName }: WelcomeMessageProps): JSX.Element => {
  const { t } = useTranslation();
  const { lg } = useBreakpoint();

  return (
    <GreetingBox isReminder={false} span={14}>
      <StyledTitle color="var(--white)" level={5} fontSize={lg ? '42px' : '26px'}>
        {t('life.home.hello', { memberName: policyHolderFirstName })}
      </StyledTitle>
      <StyledTitle color="var(--white)" level={4} fontSize={lg ? '17px' : '15px'}>
        {t('life.home.alerts', { num: alertsNum })}
      </StyledTitle>
    </GreetingBox>
  );
};
